export default __webpack_public_path__ + "7b8313b4f2edca776322d56ff03dca69.svg";